import React, { useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import ReportService from '../../../services/ReportService'
import LocalStorageService from '../../../services/LocalStorageService'
import NotificationService from '../../../services/NotificationService'
import UserTagService from '../../../services/UserTagService'

import moment from 'moment'

// Font Awesome

// Appt Components
import Anchor from '../../../components/simple/anchor/Anchor'
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider'
import FieldBox from '../shared/FieldBox.js'
import Form from '../../../components/simple/form/Form.js'
import FormField from '../../../components/simple/formField/FormField.js'
import FormFieldRequired from '../../../components/simple/formField/FormFieldRequired.js'
import Select from '../../../components/simple/input/Select'
import IncidentSearchResults from './IncidentSearchResults.js'
import JoinBox from '../shared/JoinBox.js'
import OperatorBox from '../shared/OperatorBox.js'
import Text from '../../../components/simple/text/Text'
import TextInput from '../../../components/simple/input/TextInput'
import ValueBox from '../shared/ValueBox.js'
import IncidentLinkBar from './shared/IncidentLinkBar.js'
import constants from '../../../utils/constants.js'

// Shared Components
import BreadcrumbBar from '../../shared/BreadcrumbBar'
import ActionButton from '../../../components/compound/actionButton/ActionButton.js'
import { isServiceAdmin } from '../../../utils/permissions.js'
import PulseLoader from 'react-spinners/PulseLoader.js'

function IncidentSearchGlobal (props) {
  const navigate = useNavigate()

  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')
  const activeUser = LocalStorageService.get('userDetails')

  const [criteriaIndex, setCriteriaIndex] = useState(0)

  const [fields, setFields] = useState([])

  const [query, setQuery] = useState({
    'Field-0': '',
    'Value-0': ''
  })
  const [queryResults, setQueryResults] = useState()

  // Add to Quick Search has been clicked
  // so request the name
  const [getQuickSearchName, displayQuickSearchName] = useState(false)

  // List of Quick Searches
  const [quickReportSearches, setQuickReportSearches] = useState([])

  // Selected Quick Search
  const [quickSearchSelected, setQuickSearchValue] = useState([])

  // Selected Quick Search
  const [fullSelectedQuickSearch, setFullSelectedQuickSearch] = useState([])

  // Set the submission type for the prop passed in
  const [submissionType, setSubmissionType] = useState(props.submissionType)

  // Query after being built
  // const [builtQuery, setBuiltQuery] = useState()

  const [loading, setLoading] = useState(false)
 

  // Save the Quick Search just to Local Storage for now
  const saveQuickSearch = async (searchesToSave) => {
    var searchToSubmit = []
    searchToSubmit.push({
      organisation: activeOrg.id,
      user: activeUser.id,
      key: 'quickSearch',
      // type: 'incidentSearch',
      value: JSON.stringify(searchesToSave)
    })

    const tagSet = await UserTagService.set(apiToken, searchToSubmit)
    if (tagSet.error) {
      NotificationService.error(tagSet.error)
    } else {
      NotificationService.success('Quick Search has been saved')
    }
  }

  // Save the Quick Search just to Local Storage for now
  const submitQuickSearch = async (values) => {
    const queryToSave = await buildQuery()
    // const queryToSave = builtQuery

    const queryObject = {}

    queryObject.name = values.quickSearchName
    queryObject.query = queryToSave

    const searchToSubmit = []

    var quickSearchArray = quickReportSearches

    quickSearchArray.push(queryObject)

    searchToSubmit.push({
      organisation: activeOrg.id,
      user: activeUser.id,
      key: 'quickSearch',
      // type: 'incidentSearch',
      value: JSON.stringify(quickSearchArray)
    })

    const tagSet = await UserTagService.set(apiToken, searchToSubmit)

    if (tagSet.error) {
      NotificationService.error(tagSet.error)
    } else {
      values.quickSearchName = ''
      displayQuickSearchName(false)
      NotificationService.success('Quick Search has been saved')
    }
  }



  const getQuickSearches = () => {
    (async () => {
      const params = {
        fields: 'id,type,key,value',
        limit: 100,
        orgId: activeOrg.id
      }

      const where = {
        organisation: activeOrg.id,
        user: activeUser.id,
        key: 'quickSearch',
      }

      const quickSearches = await UserTagService.get(apiToken, params, where)

      var searches = []

      if (quickSearches !== undefined) {
        for (const search of quickSearches) {
          if (search.value) {
            try {
              var value = JSON.parse(search.value)
              searches = searches.concat(value)
              searches = [...new Map(searches.map(item => [item.name, item])).values()]
              // if (value) {
              //   searches.push(value)
              // }
            } catch (err) {
              console.error(err)
            }
          }
        }
      }

      // sort by name
      searches.sort((a, b) => {
        if (a.name < b.name) {
          return -1
        }
        if (a.name > b.name) {
          return 1
        }
        return 0
      })

      if (searches.length) {
        setQuickReportSearches(searches)
      } else {
        setQuickReportSearches([])
      }
    })()
  }

  useEffect(() => {
    let unmounted = false

    if (!unmounted) {
      getQuickSearches()
    }

    return () => { unmounted = true }
  }, [])

  const goBack = () => {
    navigate(-1)
  }

  // If a different field has been selected then
  // set the field type of the field selected
  // so that the Operator dropdown can be
  // populated accordingly
  const handleFieldChanged = (fieldName, value) => {
    const fieldIndex = fieldName.substring(fieldName.indexOf('-') + 1)
    const newFields = fields

    newFields[fieldIndex] = value

    setFields(newFields)
  }

  // Delete a Criteria row
  const removeCriteria = (index) => {

    // Remove the query
    if (query && query[`Field-${index}`]) {
      delete query[`Field-${index}`]
    }

    if (query && query[`Query-${index}`]) {
      delete query[`Query-${index}`]
    }

    if (query && query[`Value-${index}`]) {
      delete query[`Value-${index}`]
    }

    if (query && query[`Join-${index}`]) {
      delete query[`Join-${index}`]
    }

    // Rename the remaining query keys
    // eg. Field-1 -> Field-0
    //
    // if current key > index decrement by 1
    const newQuery = {}

    for (const item in query) {
      const fieldName = item.split('-')[0]
      let fieldIndex = item.split('-')[1]
      const fieldValue = query[fieldName.concat('-', fieldIndex)]

      if (parseInt(fieldIndex) > index) {
        fieldIndex--
      }

      newQuery[fieldName.concat('-', fieldIndex)] = fieldValue
    }

    // Update new values
    const newFields = fields

    newFields.splice(index, 1)
    setFields(newFields)

    setQuery(newQuery)
    setCriteriaIndex(criteriaIndex - 1)
    buildCriteria()
  }

  // When Field changes default the Query box to the first option
  const setDefaultOperatorValue = (defautValue, index) => {
    if (query && query[`Field-${index}`]) {
      query[`Query-${index}`] = defautValue
    }
  }

  const criteriaRow = (index) => {
    return (
      <Box direction='row-responsive' gap='medium' key={index}>
        <FormField
          direction='column'
          label='Field'
          name={`Field-${index}`}
        >
          <FieldBox
            handleFieldChanged={handleFieldChanged}
            name={`Field-${index}`}
          />
        </FormField>

        <FormField
          direction='column'
          label='Query'
          name={`Query-${index}`}
        >
          <OperatorBox
            index={index}
            name={`Query-${index}`}
            type={fields[index]?.type}
            operators={fields[index]?.operators}
            setDefaultOperatorValue={setDefaultOperatorValue}
            fieldType={fields[index]?.value}
            query={query}
          />
        </FormField>

        <FormField
          direction='column'
          label='Value'
          name={`Value-${index}`}
        >
          <ValueBox
            name={`Value-${index}`}
            type={fields[index]?.type}
            list={fields[index]?.list}
            fieldType={fields[index]?.value}
            index={index}
            query={query}
          />
        </FormField>

        <ActionButton labelIcon={['fal', 'minus-circle']} margin={{ horizontal: 'xsmall', vertical: 'medium' }} style={{ background: 'besmartOrange' }} onClick={() => removeCriteria(index)} target='_self' />
      </Box>
    )
  }

  const buildCriteria = () => {
    const criteriaTable = []

    for (let i = 0; i <= criteriaIndex; i++) {
      criteriaTable.push(criteriaRow(i))
    }

    if (criteriaIndex > 0) {
      criteriaTable.push(
        <Box direction='row-responsive' gap='medium'>
          <FormField
            direction='column'
            label='Find results that match'
            name='Join'
          >
            <JoinBox
              name='Join'
            />
          </FormField>
        </Box>)
    }

    return criteriaTable
  }

  const addCriteria = () => {
    // default the Join to AND
    query[`Join-${(criteriaIndex + 1)}`] = 'AND'
    setQuery(query)
    setCriteriaIndex(criteriaIndex + 1)
  }

  const buildQuery = async () => {
    let endOfQuery = false
    let queryCounter = 0
    const queryArray = []

    // don't try to build a query if there are no fields
    if (!query) {
      endOfQuery = true
    }

    while (!endOfQuery) {
      if (
        query[`Field-${queryCounter}`]?.value === 'deescalationTechniques' ||
        query[`Field-${queryCounter}`]?.value === 'physicalTechnique'
      ) {
        queryArray.push({
          key: query[`Value-${queryCounter}`].split(' ').join('').toLowerCase(),
          operator: 'exists',
          response: null,

          relation: queryCounter > 0 && query.Join ? query.Join : null
        })
      } else {
        queryArray.push({
          key: query[`Field-${queryCounter}`]?.value,
          operator: query[`Query-${queryCounter}`],
          response: (query[`Field-${queryCounter}`].type === 'autocomplete' || query[`Field-${queryCounter}`].type === 'integer' || query[`Field-${queryCounter}`].type === 'text' || query[`Field-${queryCounter}`].type === 'time') ? query[`Value-${queryCounter}`] : query[`Field-${queryCounter}`].type === 'date' ? moment(query[`Value-${queryCounter}`]).format('YYYY-MM-DD') : query[`Value-${queryCounter}`].value,
          relation: queryCounter > 0 && query.Join ? query.Join : null
        })
      }

      queryCounter++
      var checkNextCriteria = `Field-${queryCounter}` in query

      if (!checkNextCriteria) {
        endOfQuery = true
      }
    }

    // setBuiltQuery(queryArray)

    const results = await getResults(queryArray)
    // setQueryResults(results)
    return queryArray
  }

  const setCriteriaFromQuickSearch = async (queryArray) => {

    let newQuery = {}
    for (const i in queryArray) {
      const savedQuery = queryArray[i]
      newQuery[`Field-${i}`] = constants.reportSearch.find((item) => item.value === savedQuery.key)
      newQuery[`Query-${i}`] = savedQuery.operator
      newQuery[`Value-${i}`] = savedQuery.response
      newQuery[`Join-${i}`] = savedQuery.relation ? savedQuery.relation : i === 0 ? null : 'AND'
    }
    setQuery(newQuery)
    setCriteriaIndex(queryArray.length - 1)
  }

  const removeQuickSearch = async (thisQuickSearch) => {
    if (window.confirm('Are you sure you want to remove this quick search?')) {
      const valuesToSave = quickReportSearches.filter(s => s.name !== fullSelectedQuickSearch.name)
      await saveQuickSearch(valuesToSave)
      getQuickSearches()
    }
  }

  const getResults = async (queryArray) => {
    if (queryArray) {
      const body = {
        submissionType: 'incidentreport',
        query: queryArray,
        reports: ['globalIncidentSearch']
      }

      const params = {
        orgId: activeOrg.id
      }

      setLoading(true)
      const results = await ReportService.getReport(apiToken, params, body)
      setLoading(false)

      if (results?.incidentSearch) {
        setQueryResults(results.incidentSearch)
      }

      return results?.incidentSearch
    }
  }
  // Basically componentDidMount
  useEffect(() => {

    // redirect if user is not a safeguarding lead
    if (!isServiceAdmin()) {
      navigate('/dashboard')
      return
    }


    buildQuery()
  }, [])

  useEffect(() => {
    buildCriteria()
  }, [fields, query])

  return (
    <Box width='xlarge'>
      <BreadcrumbBar
        title='Incidents'
        path={<><Anchor href='/'>BehaviourSmart</Anchor><Text color='besmartBlue' size='xsmall'>{window.location.pathname}</Text></>}
      />

      <IncidentLinkBar />

      {/* Quick Search */}
      {quickReportSearches &&
        <Box background='white' direction='column' gap='small' margin={{ bottom: 'medium' }} round='small' flex='grow'>
          <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small' }}>
            <Box>
              <Text size='xlarge'>Quick Search</Text>
            </Box>
            <Box alignSelf='center' direction='row'>
              <Select
                labelKey='name'
                name='quickSearch'
                onChange={({ value: nextValue }) => {
                  let selectedQuery = null
                  quickReportSearches.forEach((item) => {
                    if (item.name === nextValue) {
                      selectedQuery = item
                    }
                  })
                  setFullSelectedQuickSearch(selectedQuery)
                  setQuickSearchValue(selectedQuery.query)
                }}
                options={quickReportSearches}
                // NOTE: Normally we'd use 'query' as the key here
                // but because that is an array it seems to mess
                // things up and when selected the item does not
                // display in the dropdown. So we'll use the 'name'
                // and search for the 'query' when selected
                valueKey={{ key: 'name', reduce: true }}
              />
              <ActionButton
                disabled={!quickSearchSelected?.length}
                label='Get Search >'
                margin={{ horizontal: 'xsmall' }}
                onClick={() => setCriteriaFromQuickSearch(quickSearchSelected)}
                target='_self'
              />
              <ActionButton
                disabled={!quickSearchSelected?.length}
                label='Delete'
                grey
                margin={{ horizontal: 'xsmall' }}
                onClick={() => removeQuickSearch(quickSearchSelected)}
                target='_self'
              />
            </Box>
          </Box>
        </Box>}

      <Box background='white' direction='column' gap='small' round='small'>
        <Box
          gap='small'
          margin={{ horizontal: 'small' }}
          pad={{ horizontal: 'small', bottom: 'medium' }}
          round='small'
        >
          <Box direction='column' gap='small'>
            <Box direction='row-responsive' justify='between' pad={{ horizontal: 'none', vertical: 'small' }}>
              <Text margin={{ top: 'xsmall' }} size='large'>Search Criteria</Text>
              <Box alignSelf='center' direction='row'>
                {!getQuickSearchName &&
                  <ActionButton
                    onClick={() => {
                      // if (validateQuery()) {
                      displayQuickSearchName(true)
                      // }
                    }}
                    label='Add to Quick Search'
                    labelIcon={['fal', 'cloud-upload']}
                    margin={{ horizontal: 'xsmall' }} target='_self'
                  />}
                {getQuickSearchName &&
                  <Form
                    onSubmit={({ value: nextValue }) => {
                      submitQuickSearch(nextValue)
                    }}
                  >
                    <FormFieldRequired
                      direction='row'
                      label='Quick Search Name'
                      name='quickSearchName'
                      required
                    >
                      <TextInput
                        name='quickSearchName'
                        type='text'
                      />
                    </FormFieldRequired>

                    <ActionButton type='submit' label='Save' primary />
                  </Form>}
              </Box>
            </Box>

            <Form
              //   validate='blur'
              onChange={nextValue => {
                setQuery(nextValue)
              }}
              onSubmit={({ value: nextValue }) => {
                buildQuery(nextValue)
              }}
              value={query}
              // value={organisationDetails}
            >
              <Box direction='column' gap='xsmall' margin={{ bottom: 'small' }}>
                {buildCriteria()}
                <ActionButton label='Add Criteria' labelIcon={['fal', 'plus-circle']} color='primary' onClick={() => addCriteria()} style={{ height: '45px' }} alignSelf='start' margin={{ bottom: 'small' }} />
              </Box>
              <Box direction='row' justify='between' margin={{ top: 'medium', bottom: 'medium' }}>
                <ActionButton label='< Back' onClick={() => goBack()} secondary />
                <ActionButton disabled={criteriaIndex < 0} type='submit' label='View Results' primary />
              </Box>
              <Divider />
              <Box direction='column' gap='xsmall' margin={{ top: 'small' }}>
                {queryResults?.length > 0 &&
                  <IncidentSearchResults
                    results={queryResults}
                    terms={props.terms}
                  />}

                  

                <PulseLoader
                  size={15}
                  color='#ff8300'
                  loading={loading}
                />  
                {!loading && !queryResults?.length > 0 && <Text color='#666'>- No results to display -</Text>}
                <Divider margin={{ top: 'small' }} />
                  <Text margin={{ top: 'small', bottom: 'small' }}>Only the first 250 results are displayed. Use filters to find specific incidents.</Text>
              </Box>

            </Form>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default IncidentSearchGlobal
